import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

(function ($) {
    $(document).ready(function () {
        new Swiper('.swiper-container', {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
            },
            breakpoints: {
                1240: {
                    slidesPerView: $('.swiper-container').data('slidesPerView'),
                }
            }
        });
    });
})(jQuery);